import { Link } from "react-router-dom";

import { TrainingsList } from "@/features/chats";
import { useAdminChatOutlet } from "./AdminChatUserLayout";

import styles from "./AdminChatTrainingsPage.module.scss";

export const AdminChatTrainingsPage = () => {
  const { profile } = useAdminChatOutlet();

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <Link to=".." className={styles.back}>
          ← Назад к клиенту
        </Link>
        <h3>Программа тренировок</h3>
        <span className={styles.placeholder} />
      </div>

      <TrainingsList trainings={profile.trainings ?? []} />
    </div>
  );
};


















